// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52c4306c","453":"84ffe340","455":"df422a46","977":"3d41380a"}[chunkId] + ".chunk.js";
};